import {instanceAxios} from "@/axios/axios";
import cookie from "js-cookie";

export default function getData(url) {
    return new Promise((resolve, reject) => {
        instanceAxios.get(url, {params: {userToken: cookie.get('token')}})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}